<template>
  <div>
    <!-- 页面头部：标题不固钉，按钮单独固钉 -->
    <div class="page-header-wrap">
      <div class="page-title">权证管理</div>

      <a-affix :offset-top="10" class="page-header">
        <div class="header-action-bar">
          <a-button-group>
            <!-- 编辑 -->
            <template v-if="toDetailData.auditStatus == 1">
              <a-button @click="back">返回</a-button>
              <a-button :loading="saveLoading" @click="onSave">保存</a-button>
              <a-button
                type="primary"
                :loading="submitLoading"
                @click="onSubmit"
              >
                提交
              </a-button>
            </template>

            <!-- 审批通过 -->
            <template
              v-else-if="
                toDetailData.auditStatus == 3 && toDetailData.isEditable
              "
            >
              <a-button @click="back">返回</a-button>
              <a-button
                type="primary"
                :loading="submitLoading"
                @click="onSubmit"
              >
                提交
              </a-button>
            </template>

            <!-- 审批中/其他 -->
            <a-button v-else @click="back" type="primary">返回</a-button>
          </a-button-group>
        </div>
      </a-affix>
    </div>

    <a-page-header>
      <RightInfo
        :isEditable="toDetailData.isEditable"
        :webId="toDetailData.webId"
        ref="rightInfoRef"
        @back="back()"
      ></RightInfo>

      <!-- 回到最高点 -->
      <a-back-top style="margin-right: -100px" />
    </a-page-header>

    <a-modal
      v-model="saveLoading"
      :footer="null"
      :closable="false"
      :maskClosable="false"
      :keyboard="false"
      centered
      width="400px"
    >
      <div style="text-align: center; padding: 30px 0">
        <a-spin size="large" />
        <div
          style="
            margin-top: 30px;
            font-size: 15px;
            color: rgba(0, 0, 0, 0.65);
            font-weight: 500;
            letter-spacing: 0.5px;
          "
        >
          正在保存，请稍候...
        </div>
      </div>
    </a-modal>

    <a-modal
      v-model="submitLoading"
      :footer="null"
      :closable="false"
      :maskClosable="false"
      :keyboard="false"
      centered
      width="400px"
    >
      <div style="text-align: center; padding: 30px 0">
        <a-spin size="large" />
        <div
          style="
            margin-top: 30px;
            font-size: 15px;
            color: rgba(0, 0, 0, 0.65);
            font-weight: 500;
            letter-spacing: 0.5px;
          "
        >
          正在提交，请稍候...
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import RightInfo from "./rightsInfo/RightInfo";
import { scrollToTop } from "@/utils/util";

export default {
  props: {
    toDetailData: {
      type: Object,
      default: () => ({}),
    },
  },

  components: {
    RightInfo,
  },

  data() {
    return {
      saveLoading: false,
      submitLoading: false,
    };
  },

  methods: {
    back() {
      this.$emit("changeToLeader");
      scrollToTop(this);
    },

    async onSave() {
      if (this.saveLoading) return;

      this.saveLoading = true;

      try {
        await this.$refs.rightInfoRef.handleSave();
      } finally {
        setTimeout(() => {
          this.saveLoading = false;
        }, 400);
      }
    },

    async onSubmit() {
      if (this.submitLoading) return;

      const canSubmit = await this.$refs.rightInfoRef.beforeSubmit();

      if (!canSubmit) {
        return;
      }

      this.submitLoading = true;

      try {
        await this.$refs.rightInfoRef.handleSubmit();
      } finally {
        setTimeout(() => {
          this.submitLoading = false;
        }, 400);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.page-header-wrap {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 16px;
}

.page-title {
  padding: 0px 24px 0;
  font-size: 20px;
  font-weight: 600;
  color: #1f1f1f;
  line-height: 32px;
}

.header-action-bar {
  display: flex;
  justify-content: flex-end;
  padding: 0px 26px 0;
}

.page-header /deep/ .ant-affix {
  z-index: 1000 !important;
}
</style>